/**
 * @generated SignedSource<<faace2cb5afb92abc110c8df10f34585>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeleteAppModalMutation$variables = {
  id: string;
};
export type DeleteAppModalMutation$data = {
  readonly deleteApp: boolean;
};
export type DeleteAppModalMutation = {
  response: DeleteAppModalMutation$data;
  variables: DeleteAppModalMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "kind": "ScalarField",
    "name": "deleteApp",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteAppModalMutation",
    "selections": (v1/*:: as any*/),
    "type": "MutationRoot",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "DeleteAppModalMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "cacheID": "349d74389955b489f56f32179c7f6468",
    "id": null,
    "metadata": {},
    "name": "DeleteAppModalMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteAppModalMutation(\n  $id: ID!\n) {\n  deleteApp(id: $id)\n}\n"
  }
};
})();

(node as any).hash = "3bc8e8de3cab95dc006dcff8b631a38a";

export default node;
